import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useRequest } from 'ahooks';
import posthog from 'posthog-js';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'store/users/selectors';

export default function useCheckNotificationsPermissions() {
  const [appStateResumed, setAppStateResumed] = useState(true);
  const currentUser = useSelector(selectCurrentUser);

  App.addListener('appStateChange', ({ isActive }) => {
    setAppStateResumed(isActive);
  });
  const { run: checkPermissions, data: pushNotificationsPermissions } = useRequest(async () => {
    if (Capacitor.isPluginAvailable('PushNotifications')) {
      const permissions = await PushNotifications.checkPermissions();
      posthog.capture('$set', {
        $set: {
          gynger_push_notifications_permission: permissions.receive,
        },
      });
      return permissions;
    }
    return Promise.resolve({ receive: 'denied' });
  });

  const doesUserHavePushNotifications = pushNotificationsPermissions?.receive === 'granted';

  const doesUserHaveNotifications = doesUserHavePushNotifications || currentUser?.consents_to_email_notifications;

  useEffect(() => {
    checkPermissions();
  }, [checkPermissions, appStateResumed]);

  return { doesUserHavePushNotifications, doesUserHaveNotifications };
}
